import styled from 'styled-components';
export const List = styled.ul `
  margin: 0;
  display: flex;
  list-style: none;
  padding: 0;
  flex-wrap: wrap;
  transform: translateX(-0.625rem);
  margin-top: -1rem;

  @media ${({ theme }) => theme.device.medium} {
    margin-top: 0;
  }

  @media ${({ theme }) => theme.device.large} {
    transform: translateX(0.5rem);
  }

  > li {
    margin-right: 0.5rem;
    margin-top: 1rem;

    @media ${({ theme }) => theme.device.medium} {
      margin-top: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }

  & button {
    @media ${({ theme }) => theme.device.medium} {
      width: 2.5rem;
      height: 2.5rem;
    }

    &:active {
      svg {
        path {
          fill: ${({ theme }) => theme.colors.white};
        }
        .pinterest__path1 {
          fill: ${({ theme }) => theme.colors.grey15};
        }
      }
    }

    svg {
      width: 1.5rem;
      path {
        fill: ${({ theme }) => theme.colors.grey15};
      }
      .pinterest__path1 {
        fill: ${({ theme }) => theme.colors.white};
      }
    }
  }
`;
export const IconWrapper = styled.div `
  > button {
    & img {
      width: 1.5rem;
      height: 1.5rem;
    }
    & img[data-set='url'] {
      display: block;
    }
    & img[data-set='urlActive'] {
      display: none;
    }

    &:active {
      & img[data-set='url'] {
        display: none;
      }
      & img[data-set='urlActive'] {
        display: block;
      }
    }
  }
`;
